export const SUBMIT_INTEREST_API_NAME: string = 'interest';

export const UNKNOWN_PARTNER: string = 'UNKNOWN';
